	// lcm functions
	function gcd2(a, b) {
		// Greatest common divisor of 2 integers
		if(!b) return b===0 ? a : NaN;
		return gcd2(b, a%b);
		}
		function gcd(array) {
		// Greatest common divisor of a list of integers
		var n = 0;
		for(var i=0; i<array.length; ++i)
			n = gcd2(array[i], n);
		return n;
		}
		function lcm2(a, b) {
		// Least common multiple of 2 integers
		return a*b / gcd2(a, b);
		}
		function lcm(array) {
		// Least common multiple of a list of integers
		var n = 1;
		for(var i=0; i<array.length; ++i)
			n = lcm2(array[i], n);
		return n;
	}
	


	
	var rowsArrayHalf = [];
	var rowsArrayThird = [];
	
	function resetVars(){
		rowsArrayHalf = [];
		rowsArrayThird = [];
	}


	
	// sort which image comes in which row
	function bundleRowArray( data ){
		var itemArrayHalf = [];
		var itemArrayThird = [];
		
		var rowHalf = 1;
		var rowThird = 1;
	
		for (var i = 0; i < data.length; i++) {
	
			// half
			if( data[i].rowHalf > rowHalf ){
				rowsArrayHalf.push( itemArrayHalf ); // push everytime row gets 1 up
				itemArrayHalf = []; // reset row array
				rowHalf++;
			}
	
			// third
			if( data[i].rowThird > rowThird ){
				rowsArrayThird.push( itemArrayThird ); // push everytime row gets 1 up
				itemArrayThird = []; // reset row array
				rowThird++;
			}
	
			itemArrayHalf.push( i ); // push last item array to row
			itemArrayThird.push( i );
		}
		
		rowsArrayHalf.push( itemArrayHalf );
		rowsArrayThird.push( itemArrayThird );
	}
	



	// define width of items in a row
	function setWidthRow( data, rowArray, maxcol ){
		// if postArray
		// if key 'acf' exists in first object of array == postArray
		var arrayType;
		if( 'acf' in data[0] ){
			arrayType = 'postArray';
		}else{
			arrayType = 'project';
		}

		
		for (var i = 0; i < rowArray.length; i++) {
			var fstID = rowArray[i][0]; // lets asume there is always a first
			var sndID = ( rowArray[i][1] ) ? rowArray[i][1] : false;
			var trdID = ( rowArray[i][2] ) ? rowArray[i][2] : false;
			
			var fstWidth, fstHeight,
				sndWidth, sndHeight,
				trdWidth, trdHeight;


			var fstWidthPercentage, sndWidthPercentage, trdWidthPercentage;
			var fstHeightPercentage, sndHeightPercentage, trdHeightPercentage;


			if( arrayType === 'postArray' ){
				// get crop percentage
				fstWidthPercentage = data[fstID].acf.crop.width;
				sndWidthPercentage = ( sndID ) ? data[sndID].acf.crop.width : 100;
				trdWidthPercentage = ( trdID ) ? data[trdID].acf.crop.width : 100;

				
				fstHeightPercentage = data[fstID].acf.crop.height;
				sndHeightPercentage = ( sndID ) ? data[sndID].acf.crop.height : 100;
				trdHeightPercentage = ( trdID ) ? data[trdID].acf.crop.height : 100;


				// get image width and height
				fstWidth = data[fstID].acf.teaser_image.width; // lets asume there is always a first
				fstHeight = data[fstID].acf.teaser_image.height; // lets asume there is always a first
		
				sndWidth = ( sndID ) ? data[sndID].acf.teaser_image.width : false;
				sndHeight = ( sndID ) ? data[sndID].acf.teaser_image.height : false;
		
				trdWidth = ( trdID ) ? data[trdID].acf.teaser_image.width : false;
				trdHeight = ( trdID ) ? data[trdID].acf.teaser_image.height : false;


				// process crop percentages to image width
				fstWidth = fstWidth / 100 * fstWidthPercentage * 100 / fstHeightPercentage;
				sndWidth = sndWidth / 100 * sndWidthPercentage * 100 / sndHeightPercentage;
				trdWidth = trdWidth / 100 * trdWidthPercentage * 100 / trdHeightPercentage;



				// set padding top
				data[fstID].paddingTop = 100 / fstWidth * fstHeight;
				if( sndID ){
					data[sndID].paddingTop =  100 / sndWidth * sndHeight; }
				if( trdID ){
					data[trdID].paddingTop = 100 / trdWidth * trdHeight; }
			}


			var lcmNumber,
				fstCounter,
				sndCounter,
				trdCounter,
				totalCounter,
				totalWidthEM,
				fstNewWidth,
				sndNewWidth,
				trdNewWidth;
			
	
			if( sndID && trdID ){ // if 3 item
				
				lcmNumber = lcm( [fstHeight , sndHeight , trdHeight] );
				
				fstCounter = lcmNumber / fstHeight;
				sndCounter = lcmNumber / sndHeight;
				trdCounter = lcmNumber / trdHeight;
				totalCounter = fstCounter + sndCounter + trdCounter;
	
				totalWidthEM = (fstWidth * fstCounter) + (sndWidth * sndCounter) + (trdWidth * trdCounter);
				fstNewWidth = 100 / totalWidthEM * (fstWidth * fstCounter); // height is even
				sndNewWidth = 100 / totalWidthEM * (sndWidth * sndCounter); // height is even
				trdNewWidth = 100 / totalWidthEM * (trdWidth * trdCounter); // height is even
				
	
				data[fstID].widthThird = fstNewWidth;
				data[sndID].widthThird = sndNewWidth;
				data[trdID].widthThird = trdNewWidth;

			}
	
			else if( sndID ){ // if 2 items
	
				lcmNumber = lcm( [fstHeight , sndHeight] );
	
				fstCounter = lcmNumber / fstHeight;
				sndCounter = lcmNumber / sndHeight;
				totalCounter = fstCounter + sndCounter;
	
				totalWidthEM = (fstWidth * fstCounter) + (sndWidth * sndCounter);
				fstNewWidth = 100 / totalWidthEM * (fstWidth * fstCounter); // height is even
				sndNewWidth = 100 / totalWidthEM * (sndWidth * sndCounter); // height is even
				
				if( maxcol === 3 ){
					data[fstID].widthThird = fstNewWidth;
					data[sndID].widthThird = sndNewWidth;
				}
				if( maxcol === 2 ){
					data[fstID].widthHalf = fstNewWidth;
					data[sndID].widthHalf = sndNewWidth;
				}
			}
			else{ // if 1 item
				data[fstID].widthHalf = 50;
				data[fstID].widthThird = 50;
			}
		}
	}
	
	
	function triggerSizing( data ){
		setWidthRow(data, rowsArrayHalf, 2);
		setWidthRow(data, rowsArrayThird, 3);
	}
	





	// count trought objects and give them the correct row numbers
	function createRowArray( data, firstRowCount = 2 ){
		var count = 1;
	
		var rowHalf = 1;
		var colHalf = 1;
	
		var rowThird = 1;
		var colThird = 1;
		
		for ( var i = 0; i < data.length; i++ ) {
			// half
			if( colHalf >= 3 ){ 
				colHalf = 1; // reset col to 1
				rowHalf++; // count up row very 2 
			}
			
			data[i].rowHalf = rowHalf;
			colHalf++; // update col
	
			
			// third
			if( colThird > 3 || count === firstRowCount + 1 ){  // set 2 images for 1st row
				colThird = 1; // reset col to 1
				rowThird++; // count up row very 3 
			}
			
			data[i].rowThird = rowThird;
	
			colThird++; // update col
			count++; // update count

		}
		return data;
	}
	
	
	function assignRow( data, firstRowCount = 3 ){
		createRowArray( data, firstRowCount );
		bundleRowArray( data );	

	  // onload
		triggerSizing( data );
		resetVars();
	}

	export {assignRow}
